import React from 'react'
import LenderControl from './LenderControl'
import LenderHeroComp from './LenderHeroComp'
import LenderModeOfActions from './LenderModeOfActions'
import LenderRequestInfo from './LenderRequestInfo'
import LenderUnlockValue from './LenderUnlockValue'
import LenderWhatYouGain from './LenderWhatYouGain'
import LenderOnboarded from './LenderOnboarded'

const LenderIndex = () => {
  return (
    <React.Fragment>
      <LenderHeroComp />
      <LenderUnlockValue />
      <LenderOnboarded />
      <LenderWhatYouGain />
      <LenderModeOfActions />
      <LenderControl />
      <LenderRequestInfo />
    </React.Fragment>
  )
}

export default LenderIndex